import { render } from "./ProblemLog.vue?vue&type=template&id=558ab7c5&scoped=true"
import script from "./ProblemLog.vue?vue&type=script&lang=js"
export * from "./ProblemLog.vue?vue&type=script&lang=js"

import "./ProblemLog.vue?vue&type=style&index=0&id=558ab7c5&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558ab7c5"]])

export default __exports__